module.exports = __webpack_public_path__ + "static/uxpin_notepad_2-92e3390df51cecc1f0526369791581fa.jpg";